import {Component, forwardRef, Injector} from '@angular/core';
import {AbstractInput} from '../abstract-input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FileInputComponent)
        }
    ],
  selector: 'vui-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent extends AbstractInput {
    constructor(protected injector: Injector) {
        super(injector);
    }
}
